function errorLocation(error: GeolocationPositionError) {
  let message = "";
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message =
        "Por favor, permita el acceso a su ubicación en los ajustes del navegador.";
      break;
    case error.POSITION_UNAVAILABLE:
      message = "La información de ubicación no está disponible.";
      break;
    case error.TIMEOUT:
      message = "Se agotó el tiempo de espera para obtener la ubicación.";
      break;
    default:
      message = "Ocurrió un error desconocido al obtener la ubicación.";
      break;
  }
  return message;
}
export async function getLocacion(): Promise<{
  error: string | null;
  coords: {
    lat: number;
    lng: number;
  };
}> {
  let coords = {
    lat: 0,
    lng: 0,
  };
  let error = null;

  // 1. Verificar si el navegador soporta Geolocation
  if (navigator.geolocation) {
    // 2. Llamada a la API nativa
    try {
      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        },
      );
      coords.lat = position.coords.latitude;
      coords.lng = position.coords.longitude;
    } catch (err) {
      error = errorLocation(err as GeolocationPositionError);
    }
  } else {
    error = "Su navegador no soporta geolocalización.";
  }
  return { error, coords };
}

export async function getSimpleLocacion(): Promise<{
  error: string | null;
  coords: {
    lat: number;
    lng: number;
  };
}> {
  let coords = { lat: 0, lng: 0 };
  let error = null;

  if (navigator.geolocation) {
    try {
      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            // 1. Desactivar alta precisión (usa antenas de celular/WiFi en vez de GPS)
            enableHighAccuracy: false, 
            
            // 2. Tiempo máximo de espera (ej. 5 segundos)
            timeout: 5000, 
            
            // 3. Aceptar una ubicación guardada en caché (ej. de hace 1 minuto)
            maximumAge: 60000 
          });
        },
      );
      coords.lat = position.coords.latitude;
      coords.lng = position.coords.longitude;
    } catch (err) {
      error = errorLocation(err as GeolocationPositionError);
    }
  } else {
    error = "Su navegador no soporta geolocalización.";
  }
  return { error, coords };
}
